// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Shigeo",
  middleName: "",
  lastName: "Kitamura",
  message: "Data Engineer | Web Developer | Python | BigQuery | Ruby on Rails",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/shigeokitamura",
    },
    {
      image: "fa-facebook",
      url: "https://www.facebook.com/shigeo.kitamura/",
    },
    {
      image: "fa-instagram",
      url: "https://www.instagram.com/kitamurashigeo/",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/shigeo-kitamura-85b0a1123/.",
    },
    {
      image: "fa-twitter",
      url: "https://x.com/shigeo9462",
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/shigeokitamura.jpg"),
  imageSize: 375,
  message:
    "My name is Shigeo Kitamura. I am an experienced Data Engineer and Software Developer with over 5 years of expertise in building robust data pipelines and web applications. Proficient in Python, Ruby, and various big data technologies, with a strong background in cloud platforms, particularly Google Cloud. Demonstrates a blend of technical knowledge and educational experience, having worked as a part-time lecturer. Currently expanding knowledge in Data Science, showcasing a commitment to continuous learning and adaptability in the ever-evolving tech landscape.",
  resume: "https://github.com/shigeokitamura/shigeokitamura/blob/main/Shigeo_Kitamura_Resume.pdf",
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Recent Projects",
  gitHubUsername: "shigeokitamura", //i.e."johnDoe12Gh"
  reposLength: 0,
  specificRepos: ["financial_tracker", "horse-racing-prediction-airflow", "kaggle_NCAA_2025", "books-to-scrape"],
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    { 
      img: require("../editable-stuff/hashirshoaeb.png"), 
      label: "First slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
    { 
      img: require("../editable-stuff/hashirshoaeb.png"), 
      label: "Second slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "Ruby", value: 90 },
    { name: "Javascript / Typescript", value: 80 },
    { name: "Python", value: 75 },
    { name: "SQL / HQL", value: 85 },
    { name: "Rails", value: 90 },
    { name: "React", value: 80 },
    { name: "Airflow", value: 80 },
    { name: "PySPark", value: 75 },
  ],
  softSkills: [
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 90 },
    { name: "Positivity", value: 75 },
    { name: "Adaptability", value: 85 },
    { name: "Problem Solving", value: 75 },
    { name: "Empathy", value: 90 },
    { name: "Organization", value: 70 },
    { name: "Creativity", value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "I'm currently looking for full-time Web Developing or Data Engineering / Data Science opportunities in Canada! I have an open work permit and can move anywhere. If you know of any positions available, if you have any questions, or if you just want to say hi, please feel free to email me at",
  email: "shigeo.kitamura.work@gmail.com",
};

const experiences = {
  show: false,
  heading: "Experiences",
  data: [
    {
      role: 'Software Engineer',// Here Add Company Name
      companylogo: require('../assets/img/dell.png'),
      date: 'June 2018 – Present',
    },
    {
      role: 'Front-End Developer',
      companylogo: require('../assets/img/boeing.png'),
      date: 'May 2017 – May 2018',
    },
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch, experiences };
